var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6421 0L26.75 4.10786L23.6185 7.24078L19.5106 3.13293L22.6421 0ZM7.59644 19.1536H11.7043L21.6823 9.17558L17.5744 5.06773L7.59644 15.0457V19.1536Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6586 23.2614H7.81278C7.77717 23.2614 7.7402 23.275 7.7046 23.275C7.65942 23.275 7.61423 23.2627 7.56767 23.2614H3.48857V4.09135H12.8641L15.6026 1.35278H3.48857C1.97825 1.35278 0.75 2.57966 0.75 4.09135V23.2614C0.75 24.773 1.97825 25.9999 3.48857 25.9999H22.6586C23.3849 25.9999 24.0815 25.7114 24.595 25.1978C25.1086 24.6842 25.3971 23.9877 25.3971 23.2614V11.3924L22.6586 14.131V23.2614Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.423bc4d972453ad9ae3a69451fcafb0f.svg";
export { ForwardRef as ReactComponent };